// src/pages/EmployeesPage.jsx
import React, { useState, useEffect } from 'react';
import { Button, Input, Table, Modal, Form, Select } from 'antd';

/**
 * @param {string} API_URL     – адрес бекенда
 * @param {string} userRole    – роль текущего пользователя (engineer, champ, main_engineer)
 */
function EmployeesPage({ API_URL, userRole }) {
  const [employees, setEmployees] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [searchText, setSearchText] = useState('');
  
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  
  const [form] = Form.useForm();

  // -------- 1) Загрузка списка пользователей -----------
  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`${API_URL}/employees`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setEmployees(data);
        setFiltered(data);
      })
      .catch((err) => console.error('Ошибка загрузки /employees:', err));
  }, [API_URL]);

  // -------- 2) Поиск --------
  const handleSearch = (value) => {
    setSearchText(value);
    const filteredArr = employees.filter((emp) => {
      const first = emp.firstName?.toLowerCase() || '';
      const last  = emp.lastName?.toLowerCase()  || '';
      const phone = emp.phoneNumber?.toLowerCase() || '';
      return (
        first.includes(value.toLowerCase()) ||
        last.includes(value.toLowerCase()) ||
        phone.includes(value.toLowerCase())
      );
    });
    setFiltered(filteredArr);
  };

  const resetSearch = () => {
    setSearchText('');
    setFiltered(employees);
  };

  // -------- 3) Открытие формы редактирования --------
  const openEditModal = (record) => {
    setEditingUser(record);
    // Заполняем форму начальными значениями:
    form.setFieldsValue(record);
    setIsEditModalOpen(true);
  };

  // -------- 4) Сохранение: POST /edit_employee --------
  const handleEditEmployee = (values) => {
    const token = localStorage.getItem('token');

    fetch(`${API_URL}/edit_employee`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        id: editingUser.id,   // обязателен
        ...values             // firstName, lastName, phoneNumber, role
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // Успешно => локально обновляем employees и filtered
          setEmployees((prev) =>
            prev.map((emp) =>
              emp.id === editingUser.id ? { ...emp, ...values } : emp
            )
          );
          setFiltered((prev) =>
            prev.map((emp) =>
              emp.id === editingUser.id ? { ...emp, ...values } : emp
            )
          );

          // Закрываем модалку
          setIsEditModalOpen(false);
          setEditingUser(null);
        } else {
          alert(data.error || 'Ошибка при редактировании сотрудника');
        }
      })
      .catch((err) => {
        console.error('Ошибка при edit_employee:', err);
      });
  };

  // -------- 5) Колонки таблицы --------
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width:70 },
    { title: 'Имя', dataIndex: 'firstName', key: 'firstName' },
    { title: 'Фамилия', dataIndex: 'lastName', key: 'lastName' },
    { title: 'Телефон', dataIndex: 'phoneNumber', key: 'phoneNumber', width:150 },
    { title: 'Роль', dataIndex: 'role', key: 'role', width:120 },
    {
      title: 'Действие',
      key: 'action',
      render: (_, record) => {
        // Только для champ
        if (userRole === 'champ') {
          return (
            <Button onClick={() => openEditModal(record)}>
              Редактировать
            </Button>
          );
        } 
        return null;
      },
      width:130,
    },
  ];

  return (
    <div style={{ padding: 16 }}>
      <h1>Сотрудники</h1>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 16 }}>
        <Input.Search
          placeholder="Поиск по имени, фамилии или телефону"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
          style={{ width: 300 }}
        />
        <Button onClick={resetSearch}>Сбросить</Button>
      </div>

      <Table 
        columns={columns}
        dataSource={filtered}
        rowKey="id"
        pagination={{ pageSize: 8 }}
      />

      {/* Модалка для редактирования */}
      <Modal
        title="Редактирование сотрудника"
        open={isEditModalOpen}
        onCancel={() => {
          setIsEditModalOpen(false);
          setEditingUser(null);
        }}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleEditEmployee}
        >
          <Form.Item label="Имя" name="firstName">
            <Input />
          </Form.Item>
          <Form.Item label="Фамилия" name="lastName">
            <Input />
          </Form.Item>
          <Form.Item label="Телефон" name="phoneNumber">
            <Input />
          </Form.Item>
          <Form.Item label="Роль" name="role">
            <Select>
              <Select.Option value="engineer">engineer</Select.Option>
              <Select.Option value="champ">champ</Select.Option>
              <Select.Option value="main_engineer">main_engineer</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item style={{ marginTop: 16 }}>
            <Button type="primary" htmlType="submit">
              Сохранить
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default EmployeesPage;

